import { ApiMessage } from "../../apis";
import { Dictionary } from "vue-router/types/router";

export interface EventState {
  inviteUserClick: boolean;
  saveTreatmentClick: boolean;
  saveTreatmentRequestClick: boolean;
  updateCustomerClick: boolean;
  addCustomerClick: boolean;
  editLocationClick: boolean;
  addEmailClick: boolean;
  export: boolean;
  exportVariable: boolean;
  importVariable: boolean;
  addTreatmentRequestClick: boolean;
  apiMessages: Dictionary<ApiMessage[]>;
  breadcrumb: any;
  saveFailureTrackingClick: boolean;
  addShipmentClick: boolean;
  previewShipmentClick: boolean;
  previewClientShipmentClick: boolean;
  approveShipmentClick: boolean;
  rejectShipmentClick: boolean;
  addLicenseClick: boolean;
  saveRPAClick: boolean;
  closeFailureClick: boolean;
  jobTabClick: boolean;
  equipmentTabClick: boolean;
  addJobClick: boolean;
}

const event = {
  state: {
    inviteUserClick: false,
    saveTreatmentClick: false,
    updateCustomerClick: false,
    addCustomerClick: false,
    editLocationClick: false,
    addEmailClick: false,
    saveTreatmentRequestClick: false,
    export: false,
    exportVariable: false,
    importVariable: false,
    apiMessages: {} as Dictionary<ApiMessage[]>,
    breadcrumb: {},
    saveFailureTrackingClick: false,
    addShipmentClick: false,
    previewShipmentClick: false,
    previewClientShipmentClick: false,
    approveShipmentClick: false,
    rejectShipmentClick: false,
    addLicenseClick: false,
    saveRPAClick: false,
    closeFailureClick: false,
    jobTabClick: false,
    equipmentTabClick: false,
    addJobClick: false,
  } as EventState,

  getters: {
    inviteUserClick: (state: EventState) => state.inviteUserClick,
    saveTreatmentClick: (state: EventState) => state.saveTreatmentClick,
    saveTreatmentRequestClick: (state: EventState) => state.saveTreatmentRequestClick,
    export: (state: EventState) => state.export,
    exportVariable: (state: EventState) => state.exportVariable,
    importVariable: (state: EventState) => state.importVariable,
    apiMessages: (state: EventState) => state.apiMessages,
    updateCustomerClick: (state: EventState) => state.updateCustomerClick,
    addCustomerClick: (state: EventState) => state.addCustomerClick,
    editLocationClick: (state: EventState) => state.editLocationClick,
    addEmailClick: (state: EventState) => state.addEmailClick,
    breadcrumb: (state: EventState) => state.breadcrumb,
    saveFailureTrackingClick: (state: EventState) => state.saveFailureTrackingClick,
    addShipmentClick: (state: EventState) => state.addShipmentClick,
    previewShipmentClick: (state: EventState) => state.previewShipmentClick,
    previewClientShipmentClick: (state: EventState) => state.previewClientShipmentClick,
    approveShipmentClick: (state: EventState) => state.approveShipmentClick,
    rejectShipmentClick: (state: EventState) => state.rejectShipmentClick,
    addLicenseClick: (state: EventState) => state.addLicenseClick,
    saveRPAClick: (state: EventState) => state.saveRPAClick,
    closeFailureClick: (state: EventState) => state.closeFailureClick,
    jobTabClick: (state: EventState) => state.jobTabClick,
    equipmentTabClick: (state: EventState) => state.equipmentTabClick,
    addJobClick: (state: EventState) => state.addJobClick,
  },

  mutations: {
    SET_BREADCUMB: (state: EventState, payload: any) => {
      state.breadcrumb = payload;
    },
    INVITE_USER_CLICK: (state: EventState) => {
      state.inviteUserClick = !state.inviteUserClick;
    },
    SAVE_TREATMENT_CLICK: (state: EventState) => {
      state.saveTreatmentClick = !state.saveTreatmentClick;
    },
    SAVE_TREATMENT_REQUEST_CLICK: (state: EventState) => {
      state.saveTreatmentRequestClick = !state.saveTreatmentRequestClick;
    },
    EXPORT: (state: EventState) => {
      state.export = !state.export;
    },
    EXPORT_VARIABLE: (state: EventState) => {
      state.exportVariable = !state.exportVariable;
    },
    IMPORT_VARIABLE: (state: EventState) => {
      state.importVariable = !state.importVariable;
    },
    API_MESSAGES_RESPONSE: (state: EventState, payload: Dictionary<ApiMessage[]>) => {
        state.apiMessages = payload;
    },
    API_MESSAGES_EMPTY: (state: EventState) => {
        state.apiMessages = {};
    },
    UPDATE_CUSTOMER_CLICK: (state: EventState) => {
      state.updateCustomerClick = !state.updateCustomerClick;
    },
    ADD_CUSTOMER_CLICK: (state: EventState) => {
      state.addCustomerClick = !state.addCustomerClick;
    },
    EDIT_LOCATION_CLICK:(state: EventState) =>{
      state.editLocationClick = !state.editLocationClick;
    },
    ADD_EMAIL_CLICK: (state: EventState) =>{
      state.addEmailClick = !state.addEmailClick;
    },
    SAVE_FAILURE_TRACKING_CLICK: (state: EventState) => {
      state.saveFailureTrackingClick = !state.saveFailureTrackingClick;
    },
    ADD_SHIPMENT_CLICK: (state: EventState) => {
      state.addShipmentClick = !state.addShipmentClick;
    },
    PREVIEW_SHIPMENT_CLICK: (state: EventState) => {
      state.previewShipmentClick = !state.previewShipmentClick;
    },
    PREVIEW_CLIENT_SHIPMENT_CLICK: (state: EventState) => {
      state.previewClientShipmentClick = !state.previewClientShipmentClick;
    },
    APPROVE_SHIPMENT_CLICK: (state: EventState) => {
      state.approveShipmentClick = !state.approveShipmentClick;
    },
    REJECT_SHIPMENT_CLICK: (state: EventState) => {
      state.rejectShipmentClick = !state.rejectShipmentClick;
    },
    ADD_LICENSE_CLICK: (state: EventState) => {
      state.addLicenseClick = !state.addLicenseClick;
    },
    SAVE_RPA_CLICK: (state: EventState) => {
      state.saveRPAClick = !state.saveRPAClick;
    },
    CLOSE_FAILURE: (state: EventState) => {
      state.closeFailureClick = !state.closeFailureClick;
    },
    JOB_TAB_CLICK: (state: EventState) => {
      state.jobTabClick = true;
      state.equipmentTabClick = false;
    },
    EQUIPMENT_TAB_CLICK: (state: EventState) => {
      state.jobTabClick = false;
      state.equipmentTabClick = true;
    },
    ADD_JOB_CLICK: (state: EventState) => {
      state.addJobClick = !state.addJobClick;
    },
  },

  actions: {
  },
};

export default event;
